import { DatePicker } from '@approvalmax/ui/src/components';
import { Table } from '@approvalmax/ui/src/components';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { linesNamePrefix } from '../ExpenseSection/ExpenseSection.constants';
import { messages } from './ExpenseDateCell.messages';
import { ExpenseDateCellProps } from './ExpenseDateCell.types';

export const ExpenseDateCell: FC<ExpenseDateCellProps> = (props) => {
    const { cellProps, disabled } = props;

    const fieldName = `${linesNamePrefix}.${cellProps.item.index}.expenseDate`;
    const { setValue } = useFormContext();

    return (
        <Table.FormCell name={fieldName} {...cellProps}>
            {(params) => (
                <DatePicker
                    {...params}
                    placeholder={messages.placeholder}
                    clearable={false}
                    readOnly={disabled}
                    bordered={false}
                    size='small'
                    onChange={(value) => {
                        setValue(fieldName, value?.toISOString() ?? null, { shouldValidate: true });
                    }}
                />
            )}
        </Table.FormCell>
    );
};

ExpenseDateCell.displayName = 'ExpenseDateCell';
